export default "__VITE_ASSET__DS$GvZK3__"